import React from "react";

function ServicesCard({ title, image }) {
  return (
    <div className="services-card border border-gray-200 p-4 rounded-[20px] flex flex-col gap-[15px] p-[15px] items-center mb-1">
      <div className="services-card-image w-[98px] h-[98px] flex items-center justify-center bg-primary-100 rounded-full">
        <img src={image} alt="" />
      </div>
      <div className="services-card-content">
        <h3 className="web-h6">{title}</h3>
      </div>
    </div>
  );
}

export default ServicesCard;
